module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("Tipos de Requisição")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "btn-add-request-type",
      "to": {
        name: 'RequestTypeDetail'
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-default btn-file"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-upload"
  }), _vm._v(" Upload\n      "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".json, application/json"
    },
    on: {
      "change": function($event) {
        return _vm.importReqType($event)
      }
    }
  })]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('b-form-select', {
    staticClass: "input-sm",
    attrs: {
      "options": [{
        text: 5,
        value: 5
      }, {
        text: 10,
        value: 10
      }, {
        text: 15,
        value: 15
      }]
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite para pesquisar"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "id": "request-types-table",
      "items": _vm.requestTypes,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "owner",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.name))]) : _vm._e()])
      }
    }, {
      key: "active",
      fn: function(item) {
        return _c('span', {}, [_vm._v("\n            " + _vm._s(item.value ? 'Ativo' : 'Inativo') + "\n        ")])
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('span', {}, [_c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'RequestTypeDetail',
              params: {
                id: item.item.objectId
              }
            },
            "title": "Editar Tipo de Requisição"
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-edit"
        })]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "title": "Criar uma cópia do Tipo de Requisição"
          },
          on: {
            "click": function($event) {
              return _vm.duplicate(item.item.objectId)
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-duplicate"
        })]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "title": "Exportar o tipo de requisição para JSON"
          },
          on: {
            "click": function($event) {
              return _vm.exportReqType(item.item.objectId)
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-download"
        })])], 1)
      }
    }])
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": this.requestTypes.length,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae2d4ebc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestTypeList.vue
// module id = 1467
// module chunks = 1